/**
 * Citazione di un messaggio WhatsApp letta dal DB. Fino al 25/09/2026 il core salvava in
 * reply_to_id l'oggetto NOWEB intero ({"id","participant","body"}) serializzato: la UI non
 * trovava ne' il messaggio citato ne' il testo. Qui si leggono entrambe le forme, cosi' le
 * righe vecchie si vedono giuste anche prima (e a prescindere) dalla correzione nel DB.
 */
export function parseReplyTo(
  replyToId: string | null | undefined,
  replyToBody: string | null | undefined
): { replyToId?: string; replyToBody?: string } {
  let id = replyToId ?? undefined;
  let body = replyToBody ?? undefined;
  if (id && id.trim().startsWith('{')) {
    try {
      const obj = JSON.parse(id) as { id?: unknown; body?: unknown };
      id = typeof obj.id === 'string' && obj.id ? obj.id : undefined;
      if (!body && typeof obj.body === 'string' && obj.body) body = obj.body;
    } catch {
      id = undefined;
    }
  }
  return { replyToId: id || undefined, replyToBody: body || undefined };
}
